const siteConfig = {
	theme: "stratapoints",
	brand: {
		name: "StrataPoints",
		logo: null, // path to logo image
	},
	nav: [
		{ label: "Home", path: "/" },
		{ label: "Features", path: "/features" },
		{ label: "Pricing", path: "/pricing" },
		{ label: "Contact", path: "/contact" },
	],
	cta: { label: "Get started", path: "/contact" }, // Navbar CTA button (shown when logged out)
	authLinks: {
		login: "/login",
		dashboard: "/account",
	},
    banner: {
        message: "This site is under construction.",
        detail: "Check back later",
        dismissible: false,
    },
	footer: {
		links: [
			{ label: "Privacy", path: "/privacy" },
			{ label: "Terms", path: "/terms" },
		],
	},
	pages: [
		{
			path: "/admin",
			seo: { noIndex: true },
			template: "dash",
			props: {
				heading: "Server Dashboard",
			},
		},
		{
			path: "/theme",
			seo: { noIndex: true },
			template: "theme",
			props: {},
		},
		{
			path: "/",
			seo: {
				title: "Home",
				description: "Fast, reliable tools for teams that care about quality.",
			},
			template: "hero",
			props: {
				eyebrow: "Under construction",
				heading: "Software that gets out of your way",
				subheading: "Fast, reliable tools for teams that care about quality.",
				cta: { label: "Get started free", path: "/contact" },
				secondaryCta: { label: "See pricing", path: "/pricing" },
			},
		},
		{
			path: "/features",
			template: "features",
			props: {
				eyebrow: "What you get",
				heading: "Everything you need, nothing you don't",
				columns: 3,
				features: [
					{ icon: "⚡", heading: "Lorem ipsum", description: "dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua" },
					{ icon: "🔒", heading: "Lorem ipsum", description: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. " },
					{ icon: "🧩", heading: "Lorem ipsum", description: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur." },
				],
			},
		},
		{
			path: "/pricing",
			template: "pricing",
			props: {
				heading: "Simple, transparent pricing",
				plans: [
					{
						name: "Starter",
						price: "Free",
						period: "",
						description: "For individuals.",
						features: ["3 projects", "5GB storage"],
						cta: { label: "Get started", path: "/contact" },
						highlighted: false,
					},
					{
						name: "Pro",
						price: "$49",
						period: "/ month",
						description: "For growing teams.",
						features: ["Unlimited projects", "100GB storage", "Priority support"],
						cta: { label: "Start free trial", path: "/contact" },
						highlighted: true,
					},
					{
						name: "Enterprise",
						price: "Custom",
						period: "",
						description: "For large teams.",
						features: ["Everything in Pro", "SSO", "SLA guarantee"],
						cta: { label: "Talk to sales", path: "/contact" },
						highlighted: false,
					},
				],
			},
		},
		{
			path: "/contact",
			protected: true,
			template: "contact",
			seo: {
				noIndex: true,
			},
			props: {
				heading: "Get in touch",
				subheading: "We'll get back to you within one business day.",
				email: "hello@acmecorp.com",
				schema: [
					{
						name: "name",
						type: "text",
						label: "Full name",
						placeholder: "Jane Smith",
						rules: { required: "Name is required" },
					},
					{
						name: "email",
						type: "text",
						label: "Email",
						placeholder: "jane@example.com",
						rules: { required: "Email is required" },
					},
					{
						name: "message",
						type: "textarea",
						label: "Message",
						placeholder: "Tell us about your project...",
						rows: 5,
						rules: { required: "Message is required" },
					},
				],
			},
		},
		{
			path: "/login",
			template: "login",
			seo: {
				noIndex: true,
			},
			props: {
				heading: "Welcome back",
				subheading: "Sign in to your account",
				signupPath: "/signup",
				forgotPasswordPath: "/forgot-password",
			},
		},
		{
			path: "/signup",
			template: "register",
			seo: {
				noIndex: true,
			},
			props: {
				heading: "Create an account",
				subheading: "Get started for free today",
				loginPath: "/login",
			},
		},
		{
			path: "/account",
			protected: true,
			seo: { noIndex: true },
			template: "account",
			props: {
				heading: "My Account",
			},
		},
	],
}

export default siteConfig
